import React, { Component } from 'react';
import config from './config';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import ProductTable from './components/productTable/ProductTable.js';
import GoogleLogin from './components/googleLogin/googleLogin.js';
import HomePage from './components/Home/HomePage.js';
import Customer from './components/Customer/Customer.js';
import DevieceState from './components/DeviceState/DeviceState.js';

import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon } from "mdbreact";
import logo from './public/fasmedo_logo3_white.png';

const Procurement = () => {
  return <div>Procurement</div>
}

const Vendors = () => {
  return <div>Vendors</div>
}

const PrivateRoute = ({ isSignIn, component: Component, ...rest}) => {
  return (
    <Route
      {...rest}
      render={props =>
        isSignIn ? (
          <Component {...props}/>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSignIn: false,
      userOBJ: null,
      errorMessage: "",
      isOpen: false
    }
  }

  componentDidMount() {
    if (window.localStorage.userAccessToken && window.localStorage.userEmail && window.localStorage.userId) {
      fetch(`${global.gConfig.backend.url}/user/?_filter={"email":"${window.localStorage.userEmail}", "googleAccessToken":"${window.localStorage.userAccessToken}"}`)
        .then( res => res.json())
        .then( user => {
          if ( user !== "Employee not found") {
            this.setState({
              isSignIn: true,
              userOBJ: {
                userId: user.userId,
                email: user.email,
                accessToken: user.accessToken
              }
            });
          }
        })
        .catch( err => {console.log(err)})
    }
  }

  Login = () => {
    return this.state.isSignIn ? <Redirect to="/"/> : <GoogleLogin onGoogleSignIn={this.onGoogleSignIn}/>
  }

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  onGoogleSignIn = async (user) => {
    console.log(global.gConfig.backend.url);
    let fasproUser = await fetch(`${global.gConfig.backend.url}/user/verify/?_filter={"email":"${user.profileObj.email}"}`)
      .then( res => res.json())
      .catch( err => { this.setState({errorMessage: "account is not found"})})

    if ( fasproUser.id ) {
      await fetch(`${global.gConfig.backend.url}/user/${fasproUser.id}`, {
        method: 'put',
        headers: {'Content-type': 'application/json'},
        body: JSON.stringify({
            googleAccessToken: user.accessToken
          })
      })
        .then( res => res.json())
        .then( body => {
          if (body.email) {
            this.setState({
              isSignIn: true,
              userOBJ: {
                id: fasproUser.id,
                email: body.email,
                accessToken: body.accessToken
              }
            });
            
            window.localStorage.userId = body.id;
            window.localStorage.userEmail = body.email;
            window.localStorage.userAccessToken = body.accessToken;
          }
        })
        .catch(this.setState({errorMessage: "update error"}))
    }
  }

  render() {
    return (
      <Router>
        <div>
          <MDBNavbar style={{marginBottom: "1rem",padding: "0.5rem 1rem"}} color="cyan lighten-3" dark expand="md">
            <MDBNavbarBrand>
              <img style={{width: "auto", height: "2.5rem"}} src={logo} alt="fasmedo icon"></img>
            </MDBNavbarBrand>
            <MDBNavbarToggler onClick={this.toggleCollapse} />
            <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
              <MDBNavbarNav left>
                <MDBNavItem active>
                  <MDBNavLink to="/">Home</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink to="/production">Production</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink to="/customers">Customers</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink to="/procurement">Procurement</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink to="/vendors">Vendors</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink to="/device">Device</MDBNavLink>
                </MDBNavItem>
              </MDBNavbarNav>
              <MDBNavbarNav right>
                {this.state.isSignIn
                  ? [<MDBNavItem key="email">
                      <MDBNavLink to="#!">{this.state.userOBJ.email}</MDBNavLink>
                    </MDBNavItem>
                    ,
                    <MDBNavItem key="google icon">
                      <MDBDropdown>
                        <MDBDropdownToggle nav caret>
                          <MDBIcon icon="user" />
                        </MDBDropdownToggle>
                        <MDBDropdownMenu className="dropdown-default" right>
                          <MDBDropdownItem href="#!">User Info</MDBDropdownItem>
                          <MDBDropdownItem href="#!">Logout</MDBDropdownItem>
                        </MDBDropdownMenu>
                      </MDBDropdown>
                    </MDBNavItem>]
                  : <MDBNavItem>
                      <MDBNavLink className="waves-effect waves-light" to="/login">
                        <MDBIcon fab icon="google" />
                      </MDBNavLink>
                    </MDBNavItem>}
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBNavbar>
          <PrivateRoute isSignIn={this.state.isSignIn} path="/" exact component={HomePage} />
          <PrivateRoute isSignIn={this.state.isSignIn} path="/production" exact component={ProductTable} />
          <PrivateRoute isSignIn={this.state.isSignIn} path="/customers" exact component={Customer} />
          <PrivateRoute isSignIn={this.state.isSignIn} path="/procurement" exact component={Procurement} />
          <PrivateRoute isSignIn={this.state.isSignIn} path="/vendors" exact component={Vendors} />
          <PrivateRoute isSignIn={this.state.isSignIn} path="/device" exact component={DevieceState} />
          <Route path="/login" exact component={this.Login} />
        </div>
      </Router>
    );
  }
}

export default App;
